import React from 'react';
import {AiFillMail, AiFillLinkedin, AiFillInstagram, AiFillGithub, AiFillFacebook} from "react-icons/ai";

export default function SocialMediaIcons() {

  return (
    <div className="socialmediaicons">
        <ul>
            <li><a href="https://www.linkedin.com/in/krupali-desai-17269a235/" target='blank' rel='noopener noreferrer' className='linkedin'><AiFillLinkedin/></a></li>
            <li><a href="https://github.com/dkrupali56" target='blank' rel='noopener noreferrer' className='github'><AiFillGithub/></a></li>
            <li><a href="https://instagram.com/k_rdesai03/" target='blank' rel='noopener noreferrer' className='instagram'><AiFillInstagram/></a></li>
            <li><a href="https://www.facebook.com/krupali.desai.71404?mibextid=ZbWKwL"  target='blank' rel='noopener noreferrer'className='facebook'><AiFillFacebook/></a></li>
            <li><a href="mailto:dkrupali65@gmail.com" target='blank' rel='noopener noreferrer' className='mail'><AiFillMail/></a></li>
        </ul>
    </div>
  )
}
